import { createRouter } from "@tanstack/react-router";

// Import the generated route tree (may not exist yet)
import { routeTree } from "../../routeTree.gen";

// Register the router instance for type safety
declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

// Create a new router instance
export const router = createRouter({
    routeTree,
    defaultPreload: "intent",
});
